import { AxiosError } from 'axios';

const shouldDisableErrorHandlerByStatusNums = (statusNums: number[] = []) => ({ response }: AxiosError): boolean => {
	const { status } = response || {};

	return Boolean(status && statusNums.includes(status));
};

export default shouldDisableErrorHandlerByStatusNums;
